import { render, staticRenderFns } from "./transparencyDetail.vue?vue&type=template&id=546e7c80"
import script from "./transparencyDetail.vue?vue&type=script&lang=js"
export * from "./transparencyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports